import 'arrayq';
import { PureConnect, React } from '../../react';
import { Modal } from '../modal/index';
import { INote, INoteShared, IParticipant, IQuestionDB, IUsergroup, isSharedNote } from '../../types';
import { notesEditor } from '../notes/resource';
import cx from './style.less';
import authSelectors from '../../auth/selectors';
import notesSelector from '../notes/selectors';
import questionSelector from '../question/selectors';
import selectorsParticipantPopup from '../noteParticipantSelectPopup/selectors';
import selectorsCategoryPopup from '../categorySelectPopup/selectors';
import { participantsResource } from '../../participant/resource';
import FocusLockFocusGuard from '../../focuslock/focuslockext';
import windowSelectors from '../../window/selectors';
import INSPECT from '../notes/actions/NOTES_INSPECT';
import { QuestionDetailsControl } from './details';
import { Btn } from '../../react-toolbox-redesign/button';
import { NoteChatEditArea, NoteChatSaveArea } from '../notechat/editChatArea';
import { notechatEditor } from '../notechat/resource';
import selectorsLinking from '../question/selectors';
import { usergroupResource } from '../../usergroup/resource';
import { questionsResource } from './resource';
import { canChangeQuestion, statusNieuw, statusses } from './authmodule/authcheck';
import { beheerResource } from '../../admin/resource';

interface IPropsNotesInspectButtons {
    item: INote | INoteShared;
}

export default PureConnect(`QuestionInspectModal`)(
    (state) => ({
        user: authSelectors.user(state),
        userparticipant: participantsResource.selectors.items(state).qFirst((itm) => itm.isUser),
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),        
        updating: notechatEditor.selectors.updating(state),
        creatingNote: notesEditor.selectors.creating(state),
        updatingNote: notesEditor.selectors.updating(state),        
        selectNote: state.selection.creating,
        selectTextArea: state.selection.creating,
        screenSmall: windowSelectors.small(state),
        isminimized: notesSelector.isminimized(state),
        flyoverVisible: state.flyover.visible,
        inspectItem: notesSelector.inspect(state),
        inspectQuestion: questionSelector.inspect(state),
        linking: selectorsLinking.linking(state),
        ismaximized: questionSelector.ismaximized(state),
    }),
    (dispatch) => ({
        cancelInspect: () => dispatch(INSPECT({ item: undefined })),
        doinspect: (item: INote | INoteShared) => dispatch(INSPECT({ item: item })),
    }),
    ({ flyoverVisible, inspectItem, inspectQuestion, linking, isminimized, screenSmall, ismaximized, cancelInspect, updating, creatingNote, updatingNote, selectNote, participantPopupVisible, categoryPopupVisible, selectTextArea }) => {
        var visibleChatUpdate = updating && !creatingNote && !updatingNote && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
        let inspecting: boolean = !!inspectItem && inspectItem.isquestion;
        return (
            <Modal onEscKeyDown={() => cancelInspect()}
                visible={!flyoverVisible && (inspecting)}
                type={screenSmall ? 'smallscreen': ismaximized? 'maximized': 'center2nd' }
                backdrop={true}
                minimized={isminimized}
                header={<div className={cx('app')}></div>}
            >
                
                <div className={cx((!inspecting) || isminimized ? 'wcag-invisible' : '', 'fields-container')}
                    aria-hidden={!(inspecting) || isminimized}
                    aria-labelledby="Maak een notitie aan">
                    <FocusLockFocusGuard disabled={!(inspecting)}>
                        <div className={cx('note-details', !flyoverVisible && !visibleChatUpdate && (inspectItem) && !linking ? '' : 'wcag-invisible')}>
                            <QuestionDetailsControl item={inspectItem} itemQuestion={inspectQuestion}/>
                            <QuestionInspectButtons item={inspectItem} />
                        </div>
                        <div className={cx('chat-details', !flyoverVisible && visibleChatUpdate && (inspectItem) ? '' : 'wcag-invisible')}>
                            <NoteChatEditArea />
                            <NoteChatSaveArea />
                        </div>
                    </FocusLockFocusGuard>
                </div>
            </Modal>
        );
});

export const QuestionInspectButtons = PureConnect<any | IPropsNotesInspectButtons>(`QuestionInspectButtons`)(
    (state) => ({
        origin: state.notemenu.origin,
        screenSmall: windowSelectors.small(state),
        isminimized: notesSelector.isminimized(state),
        inspectItem: notesSelector.inspect(state),
        flyoverVisible: state.flyover.visible,
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup),
        allQuestions: questionsResource.selectors.items(state),
        beheer: beheerResource.selectors.items(state),
    }),
    (dispatch) => ({
        cancelInspect: () => dispatch(INSPECT({ item: undefined })),
        editNote: (item: INote) => {
            dispatch(INSPECT({ item: undefined }));
            dispatch(notesEditor.actions.UPDATE({ item }));
        },

    }),
    ({ inspectItem, editNote, flyoverVisible, cancelInspect, allparticipants, allQuestions, allparticipantsgroups, beheer }) => {

        let visible: boolean = !flyoverVisible && !!inspectItem && inspectItem.isquestion;
        let isShared = isSharedNote(inspectItem);

        const currentUser =  allparticipants.qWhere((i: IParticipant) =>i.isUser).qFirst();
        const currentUserId =  currentUser ? currentUser.id: ''; 
        var admin = beheer && beheer.qAny() && beheer.qFirst();

        var itemQuestion = null;
        var status= statusNieuw;
        var canChange = false;
        if (inspectItem.isquestion) {
            itemQuestion = allQuestions.qFirst((o: IQuestionDB) => o.noteId === inspectItem.id) as IQuestionDB;
            status = !!itemQuestion && itemQuestion.status ? itemQuestion.status: statusNieuw;
        }
        var canChange = !!itemQuestion && canChangeQuestion(statusses, status, currentUserId, allparticipantsgroups, admin) ||
        !itemQuestion && !isShared;

        return (
            <div className={cx('bottom-panel', (!visible) ? 'wcag-invisible' : '')}
                aria-hidden={!(visible)}
                aria-labelledby="Sluit het inzien scherm">
                {/* WCAG (button):
                        1) no role; they are buttons
                        2) focussable (Tab)
                        3) toggle function: n/a (when true use aria-checked)
                        4) aria-expanded: n/a
                        5) aria-haspopup: n/a  
                        6) aria-labelledby/aria-describedby: ref to label
                        7) icon of button is explained by tekst-> aria-hidden*/}
                <div className={cx('buttons-container', !visible ? 'wcag-invisible' : '')}>
                    {canChange ? 
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Bewerken'}
                            aria-haspopup={false}
                            tabIndex={0}
                            disabled={false}
                            onKeyDown={(evt: any) => { handleEnters(evt, () => editNote(inspectItem)); }}
                            onClick={() => editNote(inspectItem)}
                        >
                            <span>Bewerken</span>
                        </Btn> : null 
                    }
                    <Btn
                        type="button"
                        className={'btn'}
                        aria-label={'Sluiten'}
                        aria-haspopup={false}
                        tabIndex={0}
                        onKeyDown={(evt: any) => {
                            handleEnters(evt, () => { cancelInspect(); });
                        }}
                        onClick={() => { cancelInspect(); }}
                    >
                        <span>Sluiten</span>
                    </Btn>
                </div>

            </div>

        );
    });

function handleEnters(evt: any, funct: () => void) {
    if (evt.key === 'Enter') { evt.preventDefault(); funct(); }
}   



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/questionInspectModal.tsx